import { createApp } from 'vue';
export function initComponent({ name, component, target, store, storeKey, router }) {
    const targets = document.querySelectorAll(target);
    if (!targets.length)
        return;
    targets.forEach(element => {
        const app = createApp({});
        store && app.use(store, storeKey);
        router && app.use(router);
        app.component(name, component);
        app.mount(element);
    });
}
